import React, { useState, useEffect } from "react";
import styles from "./SearchInput.module.css";

const SearchInput = ({ handleKeyDown, placeholder = "Search...", value = "" }) => {
  const [inputValue, setInputValue] = useState(value);

  // ✅ Sync internal state when parent value changes
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const onChangeHandler = (event) => {
    setInputValue(event.target.value);
  };

  const onKeyDownHandler = (event) => {
    if (event.key === "Enter") {
      handleKeyDown(inputValue);
    }
  };

  return (
    <div className="container-fluid mt-4 p-0">
      <div
        className={`input-group rounded ${styles.searchWrapper}`}
        style={{ width: "50%" }}
      >
        <span
          className={`input-group-text bg-white border-end-0 ${styles.iconWrapper}`}
        >
          <i className="fas fa-search" />
        </span>
        <input
          type="search"
          className={`form-control ${styles.inputField}`}
          placeholder={placeholder}
          aria-label="Search"
          value={inputValue}
          onChange={onChangeHandler}
          onKeyDown={onKeyDownHandler}
        />
      </div>
    </div>
  );
};

export default SearchInput;
